import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { DataSettings } from './components/DataSettings'
import { useMainQuery } from './hooks/useMainQuery'

export const DataSettingsPage = () => {
  const { isLoading: isSurveyQueryLoading } = useSurveyForSettingsQuery()
  const { isLoading: isMainQueryLoading } = useMainQuery()

  useLogEventOnMount('Access to question and answer data upload')

  return (
    <Suspense loading={isSurveyQueryLoading || isMainQueryLoading}>
      <DataSettings />
    </Suspense>
  )
}
